export default __webpack_public_path__ + "static/media/brainster_blog_background.8cfe5dd0.svg";